import { render } from "./RecipientInfo.vue?vue&type=template&id=135a1b3a&scoped=true&ts=true"
import script from "./RecipientInfo.vue?vue&type=script&lang=ts"
export * from "./RecipientInfo.vue?vue&type=script&lang=ts"

import "./RecipientInfo.vue?vue&type=style&index=0&id=135a1b3a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135a1b3a"]])

export default __exports__